import {create} from 'zustand';

/**
 * Transient (not persisted) store that lets the current page enrich what the
 * global floating "Add to history" button captures.
 *
 * Two independent slots so a page shell and a modal inside it don't fight over
 * one value:
 *  - pageDescriptor:   the page itself (e.g. a user's sub-tab, with the user's
 *                      name). Set by the page/shell.
 *  - actionDescriptor: a re-triggerable action currently available (e.g. an
 *                      open wallet-transaction modal). Set by the modal owner
 *                      while the modal is open, cleared on close.
 *
 * The floating button prefers an actionDescriptor (a modal is open and worth
 * capturing) over the pageDescriptor, and only uses either when its `path`
 * matches the current pathname.
 *
 * descriptor shape:
 *   { path, title, subtitle, context, filters?, action? }
 * where `path` is the pathname (no query) used purely for matching.
 */
export const useHistoryContextStore = create(set => ({
  pageDescriptor: null,
  actionDescriptor: null,
  // Filters contributed by a sub-tab whose page label comes from a parent shell
  // (e.g. the user Wallet Settings tab enriching the user-page descriptor with
  // its transaction filters). Shape: { path, filters: {count, summary, data} }.
  filtersDescriptor: null,
  setPageDescriptor: descriptor => set({pageDescriptor: descriptor}),
  clearPageDescriptor: () => set({pageDescriptor: null}),
  setActionDescriptor: descriptor => set({actionDescriptor: descriptor}),
  clearActionDescriptor: () => set({actionDescriptor: null}),
  setFiltersDescriptor: descriptor => set({filtersDescriptor: descriptor}),
  clearFiltersDescriptor: () => set({filtersDescriptor: null}),
}));
